import React from "react";
import { useSpring, animated } from "react-spring";
import Images from "../../constants/Images";
import { useTranslation } from "react-i18next";
import "./descriptionSavingPlan.css";

const DescriptionSavingPlan = () => {
  const { t } = useTranslation();

  const fade = useSpring({
    from: { opacity: 0, transform: "translateY(30px)" },
    to: { opacity: 1, transform: "translateY(0)" },
    config: { duration: 800, tension: 200, friction: 20 },
  });

  return (
    <div className="beneficiary-container">
      <div className="beneficiary-hero-section">
        <div className="beneficiary-overlay-text">{t("epargnes")}</div>
      </div>

      <div className="beneficiary-intro-text">
        <p>
          Chez nous, votre package d'assurance est attribué en fonction du
          montant de votre épargne. Cela vous garantit une couverture adaptée à
          votre situation financière. Voici comment cela fonctionne :
        </p>
      </div>

      <section className="beneficiary-about-section">
        <div className="beneficiary-content-wrapper">
          <div className="beneficiary-row">
            <div className="beneficiary-col-right">
              <animated.div className="beneficiary-image-box" style={fade}>
                <img
                  src={Images.Platinium}
                  alt="About Credix"
                  className="beneficiary-image"
                />
              </animated.div>
            </div>

            <div className="beneficiary-col-left">
              <animated.div className="beneficiary-detail-box" style={fade}>
                <h2 className="beneficiary-section-title">
                  {t("DescriptionAboutPlatinium")}
                </h2>
                <p className="beneficiary-description-text">
                  {t("platinuimDescription")}
                </p>
              </animated.div>
            </div>
          </div>

          <div className="beneficiary-row">
            <div className="beneficiary-col-right">
              <animated.div className="beneficiary-image-box" style={fade}>
                <img
                  src={Images.Gold}
                  alt="About Credix"
                  className="beneficiary-image"
                />
              </animated.div>
            </div>
            <div className="beneficiary-col-left">
              <animated.div className="beneficiary-detail-box" style={fade}>
                <h2 className="beneficiary-section-title">
                  {t("DescriptionAboutGold")}
                </h2>
                <p className="beneficiary-description-text">
                  {t("goldDescription")}
                </p>
              </animated.div>
            </div>
          </div>

          <div className="beneficiary-row">
            <div className="beneficiary-col-right">
              <animated.div className="beneficiary-image-box" style={fade}>
                <img
                  src={Images.Silver}
                  alt="About Credix"
                  className="beneficiary-image"
                />
              </animated.div>
            </div>
            <div className="beneficiary-col-left">
              <animated.div className="beneficiary-detail-box" style={fade}>
                <h2 className="beneficiary-section-title">
                  {t("DescriptionAboutSilver")}
                </h2>
                <p className="beneficiary-description-text">
                  {t("silverDescription")}
                </p>
              </animated.div>
            </div>
          </div>

          <div className="beneficiary-row">
            <div className="beneficiary-col-right">
              <animated.div className="beneficiary-image-box" style={fade}>
                <img
                  src={Images.Bronze}
                  alt="About Credix"
                  className="beneficiary-image"
                />
              </animated.div>
            </div>

            <div className="beneficiary-col-left">
              <animated.div className="beneficiary-detail-box" style={fade}>
                <h2 className="beneficiary-section-title">
                  {t("DescriptionAboutBronze")}
                </h2>
                <p className="beneficiary-description-text">
                  {t("bronzeDescription")}
                </p>
              </animated.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DescriptionSavingPlan;
